
//ModalExibirParcelasVenda.js

import React from 'react';
import './ModalContasAreceber.css';

function ModalExibirParcelas({ isOpen, fecharModal, parcelasVenda, codVenda = [] }) {
  if (!isOpen) return null;

  // Log para debug
  console.log('Dados das parcelas recebidos:', parcelasVenda);

  // Função para formatar a data no formato "DD-MM-YYYY"
  const formatarData = (data) => {
  if (!data) return "Data não disponível";
  const partes = data.split('-');
  if (partes.length !== 3) return "Data inválida";
  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
  };


  // Função para formatar valores monetários
  const formatarValor = (valor) => {
    return valor ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor) : 'R$ 0,00';
  };


  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={fecharModal}>&times;</span>

        <h3>Parcelas da Venda: {codVenda}</h3>
        <table>
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Vencimento</th>
              <th translate="no">Valor</th>
            </tr>
          </thead>
          <tbody>
            {parcelasVenda.length > 0 ? (
              parcelasVenda.map((parcela, index) => (
                <tr key={index}>
                  <td>{parcela.parcela}</td>
                  <td>{formatarData(parcela.dtvencimento)}</td>
                  <td>{formatarValor(parcela.valparcela)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Nenhuma parcela disponível</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ModalExibirParcelas;

